import React from 'react';
import { personalInfo } from '../data/mock';
import { Mail, Linkedin, Github, MapPin, Phone } from 'lucide-react';
import '../styles/Contact.css';

const Contact = () => {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <h2 className="section-title">Get In Touch</h2>
        
        <div className="contact-content">
          <div className="contact-text">
            <p className="contact-description">
              I'm always open to discussing new projects, opportunities, or collaborations. 
              Feel free to reach out through any of the channels below.
            </p>
          </div>
          
          <div className="contact-links">
            <a href={`mailto:${personalInfo.email}`} className="contact-link">
              <div className="contact-link-icon">
                <Mail size={24} />
              </div>
              <div className="contact-link-content">
                <span className="contact-link-label">Email</span>
                <span className="contact-link-value">{personalInfo.email}</span>
              </div>
            </a>
            
            <a href={personalInfo.linkedin} target="_blank" rel="noopener noreferrer" className="contact-link">
              <div className="contact-link-icon">
                <Linkedin size={24} />
              </div>
              <div className="contact-link-content">
                <span className="contact-link-label">LinkedIn</span>
                <span className="contact-link-value">linkedin.com/in/ammar-alkhalissi</span>
              </div>
            </a>
            
            <a href={personalInfo.github} target="_blank" rel="noopener noreferrer" className="contact-link">
              <div className="contact-link-icon">
                <Github size={24} />
              </div>
              <div className="contact-link-content">
                <span className="contact-link-label">GitHub</span>
                <span className="contact-link-value">github.com/A2C146</span>
              </div>
            </a>
            
            <div className="contact-link static">
              <div className="contact-link-icon">
                <Phone size={24} />
              </div>
              <div className="contact-link-content">
                <span className="contact-link-label">Phone</span>
                <span className="contact-link-value">{personalInfo.phone}</span>
              </div>
            </div>
            
            <div className="contact-link static">
              <div className="contact-link-icon">
                <MapPin size={24} />
              </div>
              <div className="contact-link-content">
                <span className="contact-link-label">Location</span>
                <span className="contact-link-value">{personalInfo.location}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <footer className="footer">
        <div className="footer-content">
          <p>&copy; 2025 {personalInfo.name}. All rights reserved.</p>
          <p className="footer-subtitle">Built with React & FastAPI</p>
        </div>
      </footer>
    </section>
  );
};

export default Contact;